import React, { useState } from 'react';
import { useAppDispatch } from '../../../../app/redux/useAppSelector';
import { MenuItem } from '../../../../components/Menu';
import SVGIcon from '../../../../components/SVGIcon';
import PopOver from '../../../../components/deprecated/PopOver';
import PopOverContainer from '../../../../components/deprecated/PopOverContainer';
import annotationIcon from '../../../../icons/annotation.svg';
import reactionIcon from '../../../../icons/reaction.svg';
import EmojiPicker from '../../../../post/comment/EmojiPicker';
import Sizes from '../../../../utils/responsive/Sizes';
import { useIsSize } from '../../../../utils/responsive/isSize';
import { CREATION_ID, EditorActions } from '../../../editorSlice';
import usePickReaction from '../usePickReaction';
import styles from './ToolbarEditModeOverflowMenuButton.module.scss';
import ToolbarOverflowMenuButton from './ToolbarOverflowMenuButton';

interface ToolbarEditModeOverflowMenuButtonProps {
  closeToolbar(): void;
}
const ToolbarEditModeOverflowMenuButton = ({
  closeToolbar,
}: ToolbarEditModeOverflowMenuButtonProps) => {
  const handlePick = usePickReaction();
  const dispatch = useAppDispatch();
  const isSmall = useIsSize(Sizes.SM);
  const [isEmojiPickerOpen, setIsEmojiPickerOpen] = useState(false);

  return (
    <ToolbarOverflowMenuButton rightAlignPopOver>
      {(onClose) => (
        <>
          {/* @ts-expect-error */}
          <PopOver
            popOver={
              <PopOverContainer noPadding>
                <EmojiPicker
                  onPick={(picked: string) => {
                    handlePick(picked);
                    onClose();
                  }}
                />
              </PopOverContainer>
            }
            trigger="click"
            placement={isSmall ? 'bottom' : 'right-start'}
            preventCloseOnContentClick
            open={isEmojiPickerOpen}
            onOpenChange={(open) => {
              setIsEmojiPickerOpen(open);
              dispatch(EditorActions.setIsPickingReaction(open));
            }}
          >
            <MenuItem icon={reactionIcon}>Add reaction</MenuItem>
          </PopOver>
          <MenuItem
            icon={
              <SVGIcon className={styles.annotationIcon}>
                {annotationIcon}
              </SVGIcon>
            }
            onClick={() => {
              closeToolbar();
              dispatch(
                EditorActions.focusAnnotation({
                  id: CREATION_ID,
                  isActive: true,
                }),
              );
            }}
          >
            Add annotation
          </MenuItem>
        </>
      )}
    </ToolbarOverflowMenuButton>
  );
};
export default ToolbarEditModeOverflowMenuButton;
